import type { SearchType } from '#/modules/search/types/SearchType';
import type { SavedSearchIndex } from '#/modules/userDashboard/api/savedSearch/types/UserDashboardApiSavedSearch';

export const filterToIndex = (t: SearchType): SavedSearchIndex => {
  // oxlint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
  switch (t) {
    case 'VOLOP':
      return 'ACTIONS';

    default:
      return 'MAIN';
  }
};
